import qc from 'qc'
import {
  NodeGhostClass,
  getAllParentsBeforeScene,
  isPuzzleNode,
} from '@ps/bridge/qc/base'
import { getDescendants } from '@ps/bridge/qc/node/utils'
import store from '@ps/store'
import { libTabNameList } from '@ps/store/workbench/resource-manager/config'
import gameIframe from '@ps/bridge/iframe/iframe'
import { getIframe } from '@ps/bridge/iframe/iframe'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import qcGame from '@ps/bridge/qc/qc-game'
import assets from '@ps/bridge/qc/assets'
import _ from 'lodash'
import { scripts } from '@ps/bridge/qc/scripts'
import generateId from '@com/utils/generate-id'
import { setNodeStyleMerge } from '@ps/bridge/qc/node/layout'
import { language } from '@/common/storage'

export function makePlayPuzzle(name: string) {
  const obj = {
    id: generateId(),
    name,
    nameEn: name,
    posArr: [],
    topColor: 'rgba(10, 180, 17, 0.50)',
    preview: false,
  }
  return obj
}

export function getEmptyFilters() {
  const data = {
    // 滤镜
    blur: 0,
    hue: 0,
    luminance: 0,
    saturation: 0,
  }
  return data
}
export function getImageUrl(node: qc.Node) {
  const url = _.get(node, 'texture.atlas.img.currentSrc') || ''
  return url
}
export const getPuzzleNode = (sceneNode: qc.Node): qc.Node | undefined => {
  const nodes = getDescendants(sceneNode)
  return nodes.find((node) => isPuzzleNode(node))
}
// 拼图下的临时资源节点组
export const getPuzzleResNode = (sceneNode: qc.Node): qc.Node | null => {
  const puzzleNode = getPuzzleNode(sceneNode)
  if (!puzzleNode) return null
  let tempResourceNode = puzzleNode.getChild('tempResource')
  if (tempResourceNode) return tempResourceNode
  tempResourceNode = gameIframe.qcGame.add.node(puzzleNode)
  tempResourceNode.name = 'tempResource'
  tempResourceNode.visible = false
  setNodeStyleMerge(tempResourceNode, { visible: 0 })
  const data = editorScript.getScript(tempResourceNode)
  data.$data.nodeType = NodeGhostClass
  return tempResourceNode
}

/**
 * 祖先节点是否包含拼图组件节点
 * @param node
 */
export function hasPuzzleParent(node: qc.Node) {
  const list: [qc.Node] = getAllParentsBeforeScene(node) as [qc.Node]
  return list && list.some((node) => isPuzzleNode(node))
}

export function addPuzzleResource(config: {
  targetNode: qc.Node
  rules: string[]
  callback: any
}) {
  const data = {
    poolTabList: ['resourcePool', 'commonResource'],
    playComponentResource: true,
    currentTab: libTabNameList.PROJECT,
    currentChildTab: '',
    ...config,
    targetNode: {
      uuid: config.targetNode.uuid,
    },
  }
  if (config.callback) {
    data.callback = config.callback
  }
  console.log(data)
  store.commit('workspace/resourceManager/closeLibDialog')
  store.commit('workspace/resourceManager/updatePoolTabData', data)
  store.commit('workspace/resourceManager/openDialog', {
    category: 'commonResource',
    action: 'add',
  })
  store.commit('workspace/resourceManager/moveLibDialogNextToRight')
}

export function updatePuzzleResource(node: qc.Node, callback: any) {
  const onReplaced = () => {
    console.log('替换回调')
    //
    callback && callback()
  }
  const data = {
    targetNode: {
      uuid: node.uuid,
    },
  }
  store.commit('workspace/resourceManager/assignPoolTabData', data)
  store.commit('workspace/resourceManager/openDialog', {
    category: 'image',
    action: 'update',
    onReplaced,
  })
  store.dispatch('workspace/resourceManager/getComponents', {
    category: 'image',
  })
  store.commit('workspace/resourceManager/moveDialogToRight')
}

// 添加辅助资源节点
export async function addTempResNodeByUrl(
  url: string,
  sceneNode: qc.Node,
): qc.Node | null {
  const puzzleTempResNode = getPuzzleResNode(sceneNode)
  if (!puzzleTempResNode) return null
  const node = qcGame.add.image(puzzleTempResNode)
  const asset = await assets.load({ url })
  const Texture = gameIframe.qc.Texture
  node.texture = new Texture(asset, 0)
  store.dispatch('workspace/game/updateActiveNode', {
    node,
    record: false,
  })
  return node
}
// 更新拼图图案并切割
export async function updatePuzzleImageNCutpiece(
  sceneNode: qc.Node,
  binUrl: string,
) {
  const puzzleNode = getPuzzleNode(sceneNode)
  if (!puzzleNode) return
  const pzc = puzzleNode.getScript(scripts.puzzle.name)
  if (binUrl) {
    const asset = await assets.load({
      url: binUrl,
      override: true,
    })
    const Texture = gameIframe.texture
    pzc.puzzleImg.texture = new Texture(asset, 0)
    pzc.puzzleImg.resetNativeSize()
  }
  pzc.piecesNum = store.state.workspace.puzzle.piecesNum
  pzc.deploy()
  refreshPuzzlePieces()
}
export function refreshPuzzlePieces() {
  const sceneNode = store.state.workspace.puzzle.sceneNode
  const puzzleNode = getPuzzleNode(sceneNode)
  if (!puzzleNode) return
  const pzc = puzzleNode.getScript(scripts.puzzle.name)
  let puzzlePieces = puzzleNode
    .getChild('tableNode')
    .getChild('pieceNode').children
  puzzlePieces = puzzlePieces.map((item) => {
    const ppi = item.getScript('ps.PuzzlePieceInfo')
    return {
      bmd: ppi.bmd,
      x: item.x,
      y: item.y,
      width: item.width,
      height: item.height,
      row: ppi.row,
      col: ppi.col,
    }
  })
  store.commit('workspace/puzzle/updatePuzzlePiece', puzzlePieces)
}
// 根据imageData渲染canvas
export function renderImageData(
  imageData: ImageData,
  canvas: HTMLCanvasElement,
) {
  const ctx = canvas.getContext('2d')
  if (!ctx) return
  let tempCanvas = document.createElement('canvas')
  const tempCtx = tempCanvas.getContext('2d')
  if (!tempCtx) return
  tempCanvas.width = imageData.width
  tempCanvas.height = imageData.height

  tempCtx.putImageData(imageData, 0, 0)
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(tempCanvas, 0, 0, canvas.width, canvas.height)
  tempCanvas = null
}

export function clearPuzzleImage(sceneNode: qc.Node) {
  const puzzleNode = getPuzzleNode(sceneNode)
  if (!puzzleNode) return
  const tableNode = puzzleNode.getChild('tableNode')
  tableNode.removeSelf()
  const pzc = puzzleNode.getScript(scripts.puzzle.name)
  pzc.puzzleImg.texture = null
  // pzc.resetPuzzle() 貌似不用清空节点，因为没有底图就不能保存，还原之前的数据
  store.commit('workspace/puzzle/updateBgImage', null)
  store.commit('workspace/puzzle/updateResourceSelected', null)
  store.commit('workspace/puzzle/updatePuzzlePiece', [])
  store.commit('workspace/puzzle/updatePiecesNum', 0)
  store.commit('workspace/puzzle/updateShapeType', 0)
  store.commit('workspace/puzzle/updateBorderType', 0)
  store.commit('workspace/puzzle/updateBorderAdvancedSet', {})
  store.commit('workspace/puzzle/emptyPlayPuzzle')
}

export async function recoverPuzzleData() {
  const sceneNode = store.state.workspace.puzzle.sceneNode
  const data = store.state.workspace.puzzle.backupData
  const puzzleNode = getPuzzleNode(sceneNode)
  if (!puzzleNode) return
  const pzc = puzzleNode.getScript(scripts.puzzle.name)
  pzc.piecesNum = data.piecesNum
  pzc.shapeType = data.shapeType
  pzc.borderType = data.borderType
  pzc.borderAdvancedSet = _.cloneDeep(data.borderAdvancedSet)
  pzc.puzzlePiecesGroupSet = _.cloneDeep(data.puzzlePiecesGroupSet)
  if (data.bgImage && data.bgImage.binUrl) {
    if (!pzc.psConfig) {
      pzc.psConfig = {}
    }
    Object.assign(pzc.psConfig, {
      bgImage: _.cloneDeep(data.bgImage),
    })
    const asset = await assets.load({
      url: data.bgImage.binUrl,
      override: true,
    })
    const Texture = gameIframe.texture
    pzc.puzzleImg.texture = new Texture(asset, 0)
    pzc.puzzleImg.resetNativeSize()
    pzc.deploy()
  } else {
    pzc.puzzleImg.texture = null
    pzc.psConfig = null
    pzc.resetPuzzle()
  }
}

export function saveHandler() {
  const sceneNode = store.state.workspace.puzzle.sceneNode
  const bgImage = store.state.workspace.puzzle.bgImage
  const puzzleNode = getPuzzleNode(sceneNode)
  if (!puzzleNode) return
  setNodeStyleMerge(puzzleNode, {
    width: bgImage.width,
    height: bgImage.height,
  })
  const pzc = puzzleNode.getScript(scripts.puzzle.name)
  pzc.puzzlePiecesGroupSet = _.cloneDeep(
    store.state.workspace.puzzle.playPuzzle,
  )
  pzc.deploy()
}
// 获取整个拼图的行数和列数
export function getPuzzleBoardRowCol() {
  const sceneNode = store.state.workspace.puzzle.sceneNode
  const puzzleNode = getPuzzleNode(sceneNode)
  if (!puzzleNode) return -1
  const pzc = puzzleNode.getScript(scripts.puzzle.name)
  return {
    row: pzc._pieceComponentData.piecesV,
    col: pzc._pieceComponentData.piecesH,
  }
}

export function getIndexByRowCol(row: number, col: number) {
  const sceneNode = store.state.workspace.puzzle.sceneNode
  const puzzleNode = getPuzzleNode(sceneNode)
  if (!puzzleNode) return -1
  const pzc = puzzleNode.getScript(scripts.puzzle.name)
  return row * pzc._pieceComponentData.piecesH + col
}
// 第二步里选中类别resourceSelected的格式
export function cookPlayPuzzleData(data) {
  const lang = language.get()
  let nameKey
  if (lang === 'zh-cn') {
    nameKey = 'name'
  }
  nameKey = 'nameEn'
  return {
    id: data.id,
    imageName: data[nameKey],
    color: data.topColor,
    bottomColor: data.bottomColor,
    borderStyle: data.borderStyle,
    preview: data.preview,
  }
}
// 接缝样式默认的高级设置参数
export function getAdvanceSettingByBorderType(borderType: number) {
  const obj = {}
  const iframe = getIframe()
  const res = iframe.PuzzlePieceDrawBorder.defaultBorderStyle(obj, {
    borderStyle: borderType,
  })
  res.isEnable = true
  return res
}
